// http://admin.newdhb.com/Manager/FreightSet/getDistributionModeLists
import React from 'react'
import { SelectProps } from "antd";
import { FilterSelectPc } from '../FilterSelect/FilterSelectPc'
import { DeliverTypeItem, serviceDeliverType } from './service';
import {  useRequest  } from 'ahooks'
import { isErrorPc } from '@/component/PageComponent/errorPc';


export interface FilterDeliverTypePcProps extends SelectProps {

}

export const FilterDeliverTypePc = (props: FilterDeliverTypePcProps) => {
  const { placeholder = '发货类型', ...reset } = props;
  const [options, setOptions] = React.useState<DeliverTypeItem[]>([])
  const {run:getDeliverType,loading} = useRequest(async (params?:{kw:string})=>{
    let res = await serviceDeliverType(params)
    if(isErrorPc(res,{codeKey:"status",codeValue:"success"})){
      return
    }
    const { data } = res.data
    setOptions(data.list)
  },{manual:true})
  return <FilterSelectPc
    mode='multiple'
    defaultFilterOption
    options={options.map(item =>({label: item.name,value: item.id}))}
    getInitData={ () => getDeliverType() }
    loading={loading}
    placeholder={placeholder}
    {...reset}
  />
}